module.exports = __webpack_public_path__ + "static/media/heartPinkLargest.c1fbe7d4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/images/home-page/heartPinkLargest.svg
// module id = 131
// module chunks = 0